import { TooltipWrapper } from "ui";
import { cn } from "@/lib/utils";
import { MultiMediaProps, UnsupportedMediaWrapper } from ".";

export const MediaShare = (props: MultiMediaProps): JSX.Element => {
  const { media, onError, setIsReady, isReady } = props;
  return (
    <div data-testid="multimedia-share">
      <div className={cn("hidden", isReady && "block")}>
        <img
          src={media.payload.url}
          width="100%"
          onError={onError}
          onLoad={setIsReady}
        />
      </div>
      <div className="bg-inbox-border px-3 py-2 w-auto break-words whitespace-pre-line">
        <UnsupportedMediaWrapper>
          Shared an attachment
          <TooltipWrapper
            tooltip="We're unable to share the source of this attachment."
            placement="bottom"
          >
            <span>?</span>
          </TooltipWrapper>
        </UnsupportedMediaWrapper>
      </div>
    </div>
  );
};
